import * as React from 'react';

function Tennis(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.468 20.634c0 .12 0 .23.05.35a8.659 8.659 0 01-3.903-.67 9.04 9.04 0 01-1.645-.89 9.557 9.557 0 01-3.642-4.866l.32-.09c1.961-.423 4.01.01 5.63 1.19.285.197.556.414.812.649a7.987 7.987 0 012.378 4.327zm1.656-12.992c.25.23.514.444.793.64a6.985 6.985 0 005.538 1.169l.322-.09a9.408 9.408 0 00-3.573-4.797 8.909 8.909 0 00-1.605-.88 8.529 8.529 0 00-3.843-.67v.35a7.827 7.827 0 002.378 4.268l-.01.01zm-3.873 6.996c.18.12.361.23.532.36a8.86 8.86 0 013.331 5.266c0 .13 0 .27.06.4 4.503-1.092 7.422-5.43 6.723-9.994a9.06 9.06 0 01-7.024-1.51l-3.622 5.478zm3.622-5.477c-.19-.14-.391-.27-.572-.42a8.849 8.849 0 01-3.01-4.997c0-.14 0-.28-.06-.42-4.716.92-7.86 5.385-7.124 10.114l.401-.1a9.06 9.06 0 016.753 1.27l3.612-5.447z"
        fill="currentColor"
      />
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha'
        }}
        maskUnits="userSpaceOnUse"
        x={3}
        y={3}
        width={18}
        height={18}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.468 20.634c0 .12 0 .23.05.35a8.659 8.659 0 01-3.903-.67 9.04 9.04 0 01-1.645-.89 9.557 9.557 0 01-3.642-4.866l.32-.09c1.961-.423 4.01.01 5.63 1.19.285.197.556.414.812.649a7.987 7.987 0 012.378 4.327zm1.656-12.992c.25.23.514.444.793.64a6.985 6.985 0 005.538 1.169l.322-.09a9.408 9.408 0 00-3.573-4.797 8.909 8.909 0 00-1.605-.88 8.529 8.529 0 00-3.843-.67v.35a7.827 7.827 0 002.378 4.268l-.01.01zm-3.873 6.996c.18.12.361.23.532.36a8.86 8.86 0 013.331 5.266c0 .13 0 .27.06.4 4.503-1.092 7.422-5.43 6.723-9.994a9.06 9.06 0 01-7.024-1.51l-3.622 5.478zm3.622-5.477c-.19-.14-.391-.27-.572-.42a8.849 8.849 0 01-3.01-4.997c0-.14 0-.28-.06-.42-4.716.92-7.86 5.385-7.124 10.114l.401-.1a9.06 9.06 0 016.753 1.27l3.612-5.447z"
          fill="currentColor"
        />
      </mask>
    </svg>
  );
}

export default Tennis;
